"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./styles/_files-preview.scss");

var _commonReact = require("@devsta/common-react");

var _FilePreview = _interopRequireDefault(require("./FilePreview"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function FilePreviewList(_ref) {
  var assetIds = _ref.assetIds,
      buttonTitle = _ref.buttonTitle,
      deleteAsset = _ref.deleteAsset,
      openAssetModal = _ref.openAssetModal,
      type = _ref.type;
  return _react.default.createElement("div", null, assetIds.map(function (assetId, index) {
    return _react.default.createElement(_commonReact.AssetSelector, {
      key: assetId,
      assetId: assetId
    }, function (asset) {
      return _react.default.createElement(_FilePreview.default, {
        key: assetId,
        asset: asset,
        buttonTitle: buttonTitle,
        deleteAsset: deleteAsset(index),
        openAssetModal: openAssetModal(assetId),
        type: type
      });
    });
  }));
}

var _default = FilePreviewList;
exports.default = _default;